import axios from "../utils/axiosConfig";

const adService = {
    getAll: async (params = {}) => {
        try {
            const response = await axios.get("/advertisements", { params });
            return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },
    
    getById: async (id) => {
        try {
          const response = await axios.get(`/advertisements/${id}`);
          return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },

    create: async (data) => {
        return axios.post("/advertisements", data);
    },

    update: async (id, data) => {
        return axios.put(`/advertisements/${id}`, data);
    },

    delete: async (id) => {
        return axios.delete(`/advertisements/${id}`);
    },
};

export default adService;
